// Quantity preset buttons: add preset amount to current quantity
document.addEventListener('click', function (e) {
  const presetBtn = e.target.closest('[data-qty-preset]');
  if (!presetBtn) return;

  const input = document.querySelector('.product-form__quantity input.quantity__input');
  if (!input) return;

  input.value = String(
    parseInt(input.value, 10) + parseInt(presetBtn.getAttribute('data-qty-preset'), 10)
  );

  input.dispatchEvent(new Event('change', { bubbles: true }));
});